/**
 * Route definitions for the API credentials section (credentials list, create credential).
 * Mirrors the pattern in views/admin/dashboard-users/routes.tsx.
 */
import { RouteObject } from "react-router-dom";
import { GraphQL } from "@rpi/openapi-api";
import { withHandle } from "../../utils/route.util";
import { ApiCredentialCreateView } from "./ApiCredentialCreateView";
import { ApiCredentialsView } from "./ApiCredentialsView";

export const apiCredentialsRoutes: RouteObject[] = [
  {
    path: "api-credentials",
    element: <ApiCredentialsView />,
    ...withHandle("api-credentials"),
    children: [
      {
        path: "create",
        ...withHandle("api-credential-create", {
          requiredRole: [GraphQL.DashboardUserRole.CustomerAdmin, GraphQL.DashboardUserRole.User],
        }),
        element: <ApiCredentialCreateView />,
      },
    ],
  },
];
